<h1>システムエラー</h1>
<div fxLayout="row wrap" fxLayoutAlign="start center">
  <mat-card class="cur-card" fxFlex="100" align="center">
    <mat-card-header fxLayout="column" fxLayoutAlign="center stretch">
      <mat-card-title>システムエラーが発生しました。</mat-card-title>
      <mat-card-subtitle style="white-space: pre-wrap">{{templateMessage}}</mat-card-subtitle>
      <mat-card-subtitle>「連絡先：○○課（電話番号 000-0000-0000）」</mat-card-subtitle>
    </mat-card-header>

    <div *ngIf="!isProduction">
      <div *ngIf="systemErrorData.messageId || systemErrorData.message">
        <mat-card-content style="white-space: pre-wrap">
          <div fxLayout="row" fxLayoutAlign="center none">
            <div fxFlex="62" style="border: solid 1px;padding: 10px;">
              <div *ngIf="systemErrorData.messageId">
                <div id="messageId" style="overflow-wrap: anywhere;text-align:left;">メッセージID：{{systemErrorData.messageId}}</div>
              </div>
              <div id="message" style="overflow-wrap: anywhere;text-align:left;">{{systemErrorData.message}}</div>
            </div>
          </div>
        </mat-card-content>
      </div>
      <div *ngIf="systemErrorData.errorDetail">
        <mat-card-content style="white-space: pre-wrap">
          <div fxLayout="row" fxLayoutAlign="center none">
            <div fxFlex="62" style="border: solid 1px;padding: 10px;">
              <div id="errorDetail" style="overflow-wrap: anywhere;text-align:left;">{{systemErrorData.errorDetail}}</div>
            </div>
          </div>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>